import { jsx as _jsx } from "react/jsx-runtime";
import { useMobilityUiConfig } from '../context/MobilityUiProvider/MobilityUiProvider';
export const InfoTooltip = ({ text }) => {
    const { Tooltip, Icon } = useMobilityUiConfig();
    return (_jsx(Tooltip, { text: text, children: _jsx(Icon, { name: 'InfoOutline', color: 'greyLight' }) }));
};
